import { render, staticRenderFns } from "./DeviceGroupEditor.vue?vue&type=template&id=54245650&scoped=true"
import script from "./DeviceGroupEditor.vue?vue&type=script&lang=ts"
export * from "./DeviceGroupEditor.vue?vue&type=script&lang=ts"
import style0 from "./DeviceGroupEditor.vue?vue&type=style&index=0&id=54245650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54245650",
  null
  
)

export default component.exports